var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"editor",staticClass:"ace-container"},[_c('div',{ref:"ace",staticClass:"ace-editor"})])
}
var staticRenderFns = []

export { render, staticRenderFns }